module.exports = __webpack_public_path__ + "imgs/logo-senegskaya.9463d605.webp";